<template>
    <footer class="w3-container">
        <h6>
            <a href="http://partheas.com" target="_blank">
                <img src="/partheas.png" title="partheas.com"/>
            </a>
        </h6>
    </footer>

</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>